var React = require('react');

function SelectArrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"id":"icons","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"transform":"translate(-104.000000, -505.000000)","id":"select-arrow","fill":"#BB0104"},React.createElement("g",{"transform":"translate(104.000000, 505.000000)"},React.createElement("path",{"d":"M13,26 C5.82029825,26 0,20.1797017 0,13 C0,5.82029825 5.82029825,0 13,0 C20.1797017,0 26,5.82029825 26,13 C26,20.1797017 20.1797017,26 13,26 Z M11,17.6153846 L12.3125,19 L18,13 L12.3125,7 L11,8.38461538 L15.375,13 L11,17.6153846 Z"}))))]);
}

SelectArrow.defaultProps = {"width":"26px","height":"26px","viewBox":"0 0 26 26","version":"1.1"};

module.exports = SelectArrow;

SelectArrow.default = SelectArrow;
